"use strict";

/**
 * @generated SignedSource<<d7693964a9a8a5e7e3e06a8c19de7ffc>>
 * @relayHash 8c63f7bcf6e634a99cf92e81839f3bd0
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2295e030f823e4a9fee871e0a4c898c05ad64f21386753b83831a7bc60553849

const node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }],
    v2 = {
      "alias": null,
      "args": [{
        "kind": "Literal",
        "name": "parameters",
        "value": {
          "leadSource": "FLEET_CIB"
        }
      }],
      "kind": "ScalarField",
      "name": "quoteUrl",
      "storageKey": "quoteUrl(parameters:{\"leadSource\":\"FLEET_CIB\"})"
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "metadata": null,
      "name": "useFleetQuoteUrl_Query",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": "FleetCompany",
        "kind": "LinkedField",
        "name": "fleetCompany",
        "plural": false,
        "selections": [v2 /*: any*/],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "useFleetQuoteUrl_Query",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": "FleetCompany",
        "kind": "LinkedField",
        "name": "fleetCompany",
        "plural": false,
        "selections": [v2 /*: any*/, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }]
    },
    "params": {
      "id": "2295e030f823e4a9fee871e0a4c898c05ad64f21386753b83831a7bc60553849",
      "metadata": {},
      "name": "useFleetQuoteUrl_Query",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "9f79f94701f8edd58ffd73935b64c532";
export default node;